export enum SmarticoEvents {
  PING = 1,
  PONG = 2,
  INIT_SESSION_REQUEST = 3,
  INIT_SESSION_RESPONSE = 4,
  IDENTIFY_USER_REQUEST = 5,
  IDENTIFY_USER_RESPONSE = 6,
  LOGIN = 7,
  CLIENT_ENGAGEMENT_EVENT = 110,
  SAW_SHOW_SPING_PUSH = 707,
  REGISTER_PUSH_NOTIFICATIONS_TOKEN_REQUEST = 1003,
  REGISTER_PUSH_NOTIFICATIONS_TOKEN_RESPONSE = 2003,
}

export enum SmarticoPlatforms {
  CHROME_DESKTOP = 0,
  FIREFOX_DESKTOP = 1,
  EDGE_DESKTOP = 2,
  OPERA_DESKTOP = 3,
  SAFARI_DESKTOP = 4,
  OTHER = 5,
  NATIVE_IOS = 6,
  NATIVE_ANDROID = 7,
  CHROME_MOBILE = 8,
  FIREFOX_MOBILE = 9,
  SAFARI_MOBILE = 10,
  OPERA_MOBILE = 11,
}

export enum SmarticoPushNotificationUserStatus {
  ALLOWED = 0,
  ASK = 1,
  BLOCKED = 2,
  SUSPENDED = 3,
  NOT_SUPPORTED = 4,
}

export type SmarticoMessage = {
  cid: SmarticoEvents;
  errCode?: number;
  errMsg?: string;
  ts: number;
  uuid: string;
};

export type SmarticoConfig = {
  wsUrl: string;
  labelKey: string;
  brandKey: string;
};

export type SmarticoState = {
  popupUrl?: string;
  popups: SmarticoMessage[];
};
